import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable from '../../components/DataTablePtBr';
import Header from '../../components/Header';
import api from '../../services/api';
import { showSuccess, showError, showConfirmation } from '../../services/alert';

const RomaneioSafraList = () => {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const carregar = async () => {
    setLoading(true);

    try {
      const response = await api.get('/RomaneioSafra');
      setDados(response.data || []);
    } catch (err) {
      console.error('Erro ao carregar romaneios:', err);
      showError('Erro ao carregar romaneios.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregar();
  }, []);

  const excluir = async (id) => {
    const confirmou = await showConfirmation({
      title: 'Excluir romaneio?',
      text: 'Essa ação não pode ser desfeita.',
      confirmText: 'Sim, excluir',
      cancelText: 'Cancelar',
    });

    if (!confirmou) return;

    try {
      await api.delete(`/RomaneioSafra/${id}`);
      showSuccess('Romaneio excluído com sucesso.');
      carregar();
    } catch (err) {
      console.error('Erro ao excluir romaneio:', err);
      showError('Erro ao excluir romaneio.');
    }
  };

  const columns = [
    {
      name: 'Safra',
      selector: row => row.safraNome || '-',
      sortable: true
    },
    {
      name: 'Data',
      selector: row =>
        row.dataEntrega
          ? new Date(row.dataEntrega).toLocaleDateString()
          : '-',
      sortable: true
    },
    {
      name: 'Motorista',
      selector: row => row.motorista || '-',
      sortable: true
    },
    {
      name: 'Caminhão',
      selector: row => row.caminhao || '-',
      sortable: true
    },
    {
      name: 'Placa',
      selector: row => row.placa || '-',
      sortable: true
    },
    {
      name: 'Peso Líquido',
      selector: row =>
        Number(row.pesoLiquido || 0).toLocaleString('pt-BR'),
      sortable: true
    },
    {
      name: 'Destino',
      selector: row => row.destino || '-',
      sortable: true
    },
    {
      name: 'Ações',
      cell: row => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-outline-success btn-sm"
            onClick={() => navigate(`/romaneio-safra/editar/${row.id}`)}
          >
            <i className="bi bi-pencil-square"></i> Editar
          </button>

          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => excluir(row.id)}
          >
            <i className="bi bi-trash"></i> Excluir
          </button>
        </div>
      ),
      ignoreRowClick: true,
    },
  ];

  return (
    <div className="container mt-4">
      <Header />

      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-success text-white d-flex justify-content-between align-items-center rounded-top-3">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-light btn-sm d-flex align-items-center gap-1"
              onClick={() => navigate('/menu')}
              disabled={loading}
            >
              <i className="bi bi-arrow-left text-success"></i>
              <span className="text-success fw-semibold">Voltar</span>
            </button>

            <div>
              <h5 className="mb-0">Romaneio da Safra</h5>
              <small className="text-white-50">
                Gerencie entregas, caminhões, motoristas e pesos da colheita
              </small>
            </div>
          </div>

          <button
            className="btn btn-light text-success fw-bold"
            onClick={() => navigate('/romaneio-safra/novo')}
            disabled={loading}
          >
            <i className="bi bi-plus-circle"></i> Novo Romaneio
          </button>
        </div>

        <div className="card-body">
          <DataTable
            columns={columns}
            data={dados}
            pagination
            responsive
            highlightOnHover
            striped
            progressPending={loading}
            noDataComponent={
              <div className="text-muted">
                Nenhum romaneio encontrado.
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default RomaneioSafraList;